<template>
  <div class="paradigm_page_container">
    <div class="paradigm_home_product">
      <div class="paradigm_home_subTitle animated fadeInDown slow">
        <div class="paradigm_home_subTitle__title">赛码考试平台特色</div>
        <div class="paradigm_home_subTitle__memo">
          多快好省，3分钟搞定一场考试
        </div>
      </div>
      <div class="paradigm_home_product__content">
        <div class="paradigm_home_product__left animated fadeInLeft slow">
          <div
            class="paradigm_home_product__list__item"
            @mouseover="mouseoverHandler(1)"
            v-bind:class="{ active: isActive == 1 }"
          >
            <span>01</span
            ><span class="paradigm_home_product__list__item__symble">/</span
            ><span>功能强大 / 高并发稳定</span>
          </div>
          <div
            class="paradigm_home_product__list__item"
            @mouseover="mouseoverHandler(2)"
            v-bind:class="{ active: isActive == 2 }"
          >
            <span>02</span
            ><span class="paradigm_home_product__list__item__symble">/</span
            ><span>AI智能防作弊与监考</span>
          </div>
          <div
            class="paradigm_home_product__list__item"
            @mouseover="mouseoverHandler(3)"
            v-bind:class="{ active: isActive == 3 }"
          >
            <span>03</span
            ><span class="paradigm_home_product__list__item__symble">/</span
            ><span>在线测评/专业大题库</span>
          </div>
          <div
            class="paradigm_home_product__list__item"
            @mouseover="mouseoverHandler(4)"
            v-bind:class="{ active: isActive == 4 }"
          >
            <span>04</span
            ><span class="paradigm_home_product__list__item__symble">/</span
            ><span>考试运营服务</span>
          </div>

          <div class="btn" style="margin-top: 30px">
            <a @click="viewDetail">查看详情</a>
          </div>
        </div>
        <div class="paradigm_home_product__mac">
          <div
            class="paradigm_home_product__mac__containner animated fadeInRight slow"
          >
            <div class="map1" v-if="isActive == 1">
              <img src="@/static/images/home-three-1-map.png" />
            </div>
            <div class="map1" v-if="isActive == 2">
              <img src="@/static/images/home-three-2-map.png" />
            </div>
            <div class="map1" v-if="isActive == 3">
              <img src="@/static/images/home-three-3-map.png" />
            </div>
            <div class="map1" v-if="isActive == 4">
              <img src="@/static/images/home-three-4-map.png" />
            </div>
          </div>
          <div
            class="paradigm_home_product__text__containner animated fadeInUp slow"
          >
            <div v-if="isActive == 1">
              <ul class="txt_info font-desc">
                <li>
                  <span>支持多种模式：</span
                  >PC、移动端作答，10种题型，集中考试/随来随考等12种考试模式；
                </li>
                <li>
                  <span>快捷安排考试：</span
                  >智能题库，灵活组卷、考生/试题一键导入、精准通知、自动判分/分析；
                </li>
                <li>
                  <span>在线编译技术：</span
                  >支持20种语言在线编程自动判题，完美解决IT人才技能评定；
                </li>
                <li>
                  <span>高并发稳定：</span
                  >阿里云部署，弹性云服务器，支持30万考生并发，国家等保三级认证。
                </li>
              </ul>
            </div>
            <div v-if="isActive == 2">
              <ul class="txt_info font-desc">
                <li>
                  <span>基本手段：</span
                  >随机抽题，试题乱序、水印/自拍存档，防切屏，手机锁屏禁用，内容比对等；
                </li>
                <li>
                  <span>进阶手段：</span
                  >人脸识别，电脑正面、手机侧后方、电脑录屏三机位同时视频监控；
                </li>
                <li>
                  <span>智能利器：</span
                  >赛码AI抓作弊机器人，通过图像/声音大数据智能分析，识别出作弊嫌疑人；
                </li>
                <li>
                  <span>监考大厅：</span
                  >所有考生实时视频监控，作弊嫌疑警示，1对1红牌警告，替考警示等。
                </li>
              </ul>
            </div>
            <div v-if="isActive == 3">
              <ul class="txt_info font-14" style="margin-top: 20px">
                <li>
                  人才测评和专业能力考核，一场考试即可全部搞定。支持岗位胜任力、团队合作测评；
                  赛码可按客户要求，进行定制出题服务，目前题库涵盖：IT研发类，行测类，金融类等
                </li>
              </ul>
            </div>
            <div v-if="isActive == 4" style="margin-top: 20px">
              <ul class="txt_info font-14">
                <li>
                  赛码可代客户运营考试，设计考试方案、录题组卷，通知考生，监考答疑，出成绩报告等；
                  客户只需把考生名单给我们，剩下的事情都可以放心交给赛码来办。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 1,
    }
  },
  created() {},
  mounted() {},
  methods: {
    viewDetail() {
      this.$router.push('/product/exam')
    },
    mouseoverHandler(num) {
      this.isActive = num
    },
  },
}
</script>
<style lang="scss" scoped>
.paradigm_page_container {
  margin: 0px auto;
  width: 1200px;
  padding: 50px 0px;
  .slow {
    animation-duration: 2s;
  }

  .paradigm_home_subTitle {
    font-size: 36px;
    font-weight: 300;
  }
  .paradigm_home_product .paradigm_home_product__list__item {
    line-height: 49px;
    cursor: pointer;
    font-size: 20px;
    color: rgba(51, 51, 51, 0.5);
    font-weight: 300;
    transition: all 0.1s;
  }
  .paradigm_home_product__list__item.active
    .paradigm_home_product__list__item__symble {
    transform: rotate(68deg);
    margin-top: -5px;
    vertical-align: top;
    padding-left: 20px;
  }
  .paradigm_home_subTitle .paradigm_home_subTitle__memo {
    margin-top: 20px;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.5);
    letter-spacing: 2px;
  }
  .paradigm_home_product .paradigm_home_product__content {
    display: flex;
  }
  .paradigm_home_product .paradigm_home_product__left {
    width: 500px;
    padding-top: 74px;
    box-sizing: border-box;
  }
  .paradigm_home_product .paradigm_home_product__mac {
    width: 100%;
    height: 600px;
    margin-top: -130px;
    background-size: cover;
    background-position: center;
  }
  .paradigm_home_product
    .paradigm_home_product__mac
    .paradigm_home_product__mac__containner {
    width: 700px;
    height: 370px;
    background: url('~@/static/images/home-three-pc.png');
    background-size: cover;
    margin-top: 20px;
    padding-top: 37px;
    box-sizing: border-box;
    float: right;
  }
  .paradigm_home_product
    .paradigm_home_product__mac
    .paradigm_home_product__mac__containner
    .map1 {
    text-align: center;
    height: 270px;
  }
  .paradigm_home_product
    .paradigm_home_product__mac
    .paradigm_home_product__mac__containner
    .map1
    img {
    height: 240px;
  }
  .paradigm_home_product__text__containner {
    background: url('~@/static/images/home-three-bottom.png');
    background-size: cover;
    width: 600px;
    font-size: 12px;
    line-height: 23px;
    padding: 20px 10px 45px 20px;
    float: right;
    margin: 20px 50px 0px 0px;
    height: 179px;
  }
  .paradigm_home_product__text__containner span {
    color: #29bdb9;
    font-weight: bold;
    font-size: 14px;
  }
  .paradigm_home_product .paradigm_home_product__list__item {
    line-height: 49px;
    cursor: pointer;
    font-size: 20px;
    color: rgba(51, 51, 51, 0.5);
    font-weight: 300;
    transition: all 0.1s;
  }
  .paradigm_home_product
    .paradigm_home_product__list__item
    .paradigm_home_product__list__item__symble {
    display: inline-block;
    padding-right: 12px;
    transition: all 0.3s;
  }
  .paradigm_home_product .paradigm_home_product__list__item:hover,
  .paradigm_home_product .paradigm_home_product__list__item.active {
    color: #333333;
    font-size: 24px;
  }
}
@media screen and (max-width: 600px) {
  .paradigm_page_container {
    width: initial;
    .paradigm_home_subTitle {
      font-size: 28px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/examintro/pc.vue